import React, { useEffect } from 'react';
import {  useNavigate } from 'react-router-dom';


function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/2021-RegularSeason/766')
  }, [])


  return (
   <div>Loading...</div> 
  );
}

export default Home;
